import React, { useState } from 'react';
import styled from '../../../libs/styled.es.js';
import { useRouter } from 'next/router';
import { getTrackingData } from '@teko/tracking';
import { SvgIcon } from '../../atoms/SvgIcon/SvgIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const ScrollToTopBtn = styled.div((props) => `
  border-radius: 50%;
  background-color: ${props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
`);
const ScrollToTopWrapper = styled.div(({ showScroll, position }) => `
  display: ${showScroll ? "block" : "none"};
  z-index: 1030;
  position: fixed;
  ${position.bottom ? `bottom: ${position.bottom}rem;` : ""}
  ${position.top ? `top: ${position.top}rem;` : ""}
  ${position.left ? `left: ${position.left}rem;` : ""}
  ${position.right ? `right: ${position.right}rem;` : ""}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`);
const ScrollTopArrow = ({
  className,
  color = "#ffffff",
  backgroundColor = " #333333",
  position = { bottom: 10, right: 3 },
  scrollTopRouters
}) => {
  const router = useRouter();
  const [showScroll, setShowScroll] = useState(false);
  const scrollTopTop = () => {
    if (typeof window !== "undefined")
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  const checkScrollTop = () => {
    if (typeof window !== "undefined") {
      if (!showScroll && window.pageYOffset > 700) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 700) {
        setShowScroll(false);
      }
    }
  };
  if (typeof window !== "undefined")
    window.addEventListener("scroll", checkScrollTop);
  let hasRouter = false;
  (scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && scrollTopRouters.forEach((route) => {
    if (router.pathname.startsWith(route)) {
      hasRouter = true;
      return;
    }
  });
  if ((scrollTopRouters == null ? void 0 : scrollTopRouters.length) > 0 && !hasRouter)
    return null;
  return /* @__PURE__ */ React.createElement(ScrollToTopWrapper, __spreadValues({
    showScroll,
    position
  }, getTrackingData({
    isTrackContent: true,
    regionName: "btnScrollTop",
    contentName: "btnScrollTop"
  })), /* @__PURE__ */ React.createElement(ScrollToTopBtn, {
    className,
    onClick: () => scrollTopTop(),
    backgroundColor
  }, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "up",
    size: 24,
    color
  })));
};

export { ScrollTopArrow };
